export default {
 
  meta: {
    home: {
      title: 'DITAP - Smart Tap Solution untuk Berbagai Identitas Digital',
      description: 'DITAP menghadirkan Smart Tap Solution berbasis NFC untuk identitas digital, informasi kontak, dan kebutuhan bisnis.',
      keywords: 'ditap, smart tap, nfc, identitas digital'
    },
    about: {
      title: 'Tentang DITAP - Smart Tap Solution untuk Identitas Digital',
      description: 'Kenali DITAP, solusi NFC untuk menghubungkan identitas digital dan kebutuhan personal maupun bisnis.',
      keywords: 'tentang ditap, smart tap, nfc, identitas digital'
    },
    howItWorks: {
      title: 'Cara Kerja DITAP - 6 Langkah Mudah dengan NFC',
      description: 'Pelajari cara kerja DITAP: tap kartu NFC untuk membuka profil digital kamu. Setup dalam hitungan menit, tanpa aplikasi.',
      keywords: 'cara kerja ditap, nfc, smart tap, profil digital'
    },
    contact: {
      title: 'Hubungi DITAP - WhatsApp, Email, atau Sosial Media',
      description: 'Hubungi tim DITAP via WhatsApp, email, Instagram, atau TikTok. Kami siap membantu pertanyaan seputar smart tap solution.',
      keywords: 'hubungi ditap, kontak ditap, whatsapp ditap'
    },
    faq: {
      title: 'FAQ - Pertanyaan Umum | DITAP',
      description: 'Temukan jawaban atas pertanyaan seputar DITAP, teknologi NFC, QR Code, aktivasi akun, dan layanan identitas digital.',
      keywords: 'faq ditap, pertanyaan nfc, qr code'
    },
    blog: {
      title: 'Blog DITAP - Artikel Smart Tap & Identitas Digital',
      description: 'Baca artikel terbaru tentang smart tap solution, NFC, QR Code, dan identitas digital dari tim DITAP.',
      keywords: 'blog ditap, artikel nfc, artikel qr code'
    },
    blogDetail: {
      titleSuffix: 'DITAP Blog',
      loading: 'Memuat artikel...',
      notFound: 'Artikel tidak ditemukan'
    },
    privacyPolicy: {
      title: 'Kebijakan Privasi - DITAP',
      description: 'Baca kebijakan privasi DITAP untuk memahami bagaimana kami mengumpulkan, menggunakan, dan melindungi informasi pribadi Anda.',
      keywords: 'kebijakan privasi ditap, perlindungan data'
    },
    terms: {
      title: 'Syarat & Ketentuan - DITAP',
      description: 'Baca syarat dan ketentuan penggunaan layanan DITAP.',
      keywords: 'syarat ketentuan ditap, terms of service'
    },
    notFound: {
      title: 'Halaman tidak ditemukan - DITAP',
      description: 'Halaman yang Anda cari tidak ditemukan.'
    },
    login: {
      title: 'Login - DITAP',
      description: 'Masuk ke akun DITAP Anda.'
    },
    activateAccount: {
      title: 'Aktivasi Akun - DITAP',
      description: 'Aktifkan akun DITAP Anda dengan kode aktivasi dari produk DITAP.',
      keywords: 'aktivasi akun ditap, aktivasi ditap'
    },
    forgotPassword: {
      title: 'Lupa Password - DITAP',
      description: 'Atur ulang password akun DITAP Anda dengan verifikasi email.',
      keywords: 'lupa password ditap, reset password ditap'
    },
    resetPassword: {
      title: 'Reset Password - DITAP',
      description: 'Buat password baru untuk akun DITAP Anda.',
      keywords: 'reset password ditap, ubah password ditap'
    }
  },  

  navbar: {
    home: 'Beranda',
    about: 'Tentang',
    works: 'Cara Kerja',
    pricing: 'Harga',
    contact: 'Kontak',
    login: 'Masuk'
  },

  footer: {
    description: 'Smart Tap Solution yang menghubungkan dunia fisik dan digital melalui teknologi NFC untuk kebutuhan personal maupun bisnis.',
  
    navigationTitle: 'Navigasi',
    informationTitle: 'Informasi',
    contactTitle: 'Hubungi Kami',
  
    blog: 'Blog',
    faq: 'FAQ',
    privacy: 'Kebijakan Privasi',
    terms: 'Syarat & Ketentuan',
  
    contactDescription: 'Punya pertanyaan atau ide menarik? Mari berdiskusi bersama.',
  
    rights: 'Hak cipta dilindungi.'
  },

  hero: {
    eyebrow: 'SMART TAP SOLUTION',
    title: 'JUST TAP',
    highlight: 'IT.',
    subtitle: 'Menghubungkan dunia fisik dengan digital.',
    description: 'DITAP menghadirkan Smart Tap Solution berbasis NFC untuk menghubungkan identitas digital, informasi, dan kebutuhan bisnis dengan lebih praktis.',
    exploreProducts: 'Jelajahi Produk',
    howItWorks: 'Cara Kerja DITAP',
    visualCaption: 'SEKALI TAP. LEBIH BANYAK KEMUNGKINAN.'
  },

  b2bProof: {
    eyebrow: 'SOLUSI CERDAS UNTUK BISNIS',
    title: 'Pilihan Cerdas untuk',
    highlight: 'Bisnis Masa Kini.',
    subtitle: 'Bersama bisnis yang terus bergerak maju.',
   description: 'DITAP menghadirkan Smart Tap Solution untuk membantu bisnis menghubungkan produk fisik dengan informasi dan pengalaman digital secara praktis.'
  },

  b2cProof: {
    eyebrow: 'SMART TAP SOLUTION',
    progressLabel: 'Pilih konten',
    showSlide: 'Tampilkan konten {number}',

    slides: {
      convenience: {
        title: 'Kemudahan dalam kehidupan sehari-hari.',
        description: 'Solusi yang tepat membantu membuat aktivitas sehari-hari terasa lebih praktis.',
        imageAlt: 'Smartphone sebagai bagian dari aktivitas digital'
      },

      connected: {
        title: 'Barang yang kembali ke pemiliknya.',
        description: 'Setiap barang yang kembali memiliki cerita tersendiri.',
        imageAlt: 'Smartphone modern untuk mengakses layanan digital'
      },

      possibilities: {
        title: 'Lebih banyak peluang bersama DITAP.',
        description: 'Semakin beragam kebutuhan, semakin banyak kemungkinan yang bisa diwujudkan.',
        imageAlt: 'Teknologi digital yang mendukung aktivitas sehari-hari'
      }
    }
  },

  howItWorks: {
    eyebrow: 'CARA KERJA DITAP',
    title: 'Semudah Satu Tap.',
    description: 'Dari produk fisik menuju pengalaman digital. DITAP menghubungkan produk fisik dengan informasi digital melalui teknologi NFC.',

    stepLabel: 'LANGKAH {number}',

    steps: {
      choose: {
        caption: 'Pilih produk',
        title: 'Pilih Solusi yang Sesuai',
        description: 'Temukan produk DITAP yang dirancang untuk kebutuhan personal maupun bisnis.'
      },

      tap: {
        caption: 'Dekatkan smartphone',
        title: 'Tap dengan Smartphone',
        description: 'Dekatkan smartphone yang mendukung NFC ke produk DITAP untuk membuka tautan atau informasi yang terhubung.'
      },

      access: {
        caption: 'Akses informasi',
        title: 'Akses Manfaat Digital',
        description: 'Nikmati akses informasi atau pengalaman digital sesuai fungsi produk yang dipilih.'
      }
    },

    ctaLabel: 'SIAP MEMULAI?',
    ctaTitle: 'Saatnya membuat semuanya lebih praktis.',
    ctaDescription: 'Temukan solusi DITAP yang sesuai dengan kebutuhanmu.',
    ctaButton: 'Jelajahi Produk DITAP'
  },


  faq: {
    eyebrow: 'PERTANYAAN UMUM',
    title: 'Ada pertanyaan? Kami siap membantu.',
    description: 'Temukan jawaban seputar DITAP, teknologi NFC, dan cara penggunaannya.',
  
    contactButton: 'Hubungi Kami',
    whatsappMessage: 'Halo DITAP, saya ingin bertanya tentang produk DITAP.',
  
    questions: {
      what: {
        question: 'Apa itu DITAP?',
        answer: 'DITAP hadir untuk membuat interaksi antara dunia fisik dan digital terasa lebih mudah. Melalui teknologi NFC, informasi dapat diakses dengan cara yang lebih cepat dan praktis.'
      },
  
      how: {
        question: 'Bagaimana cara kerja DITAP?',
        answer: 'Cukup dekatkan ponsel yang mendukung NFC ke produk DITAP. Ponsel akan membuka tautan atau halaman digital yang telah dihubungkan dengan produk tersebut.'
      },
  
      tracking: {
        question: 'Apakah DITAP bisa melacak lokasi barang?',
        answer: 'Tidak. DITAP bukan pelacak GPS dan tidak menunjukkan lokasi barang secara langsung. Produk DITAP dapat membantu orang yang menemukan barang mengakses informasi kontak yang kamu bagikan, jika fitur tersebut sesuai dengan produk yang digunakan.'
      },
  
      compatibility: {
        question: 'Apakah DITAP bisa digunakan di semua ponsel?',
        answer: 'DITAP dapat digunakan pada ponsel yang mendukung NFC. Dukungan dan cara mengaktifkan NFC dapat berbeda tergantung perangkat.'
      },
  
      order: {
        question: 'Bagaimana cara mendapatkan produk DITAP?',
        answer: 'Hubungi tim DITAP untuk mendapatkan informasi tentang produk yang tersedia, harga, dan cara pemesanannya.'
      }
    }
  },

  cta: {
    eyebrow: 'JUST TAP IT.',
    title: 'Temukan Solusi',
    highlight: 'yang Tepat untukmu.',
    description: 'Temukan solusi NFC untuk kebutuhan sehari-hari maupun bisnis. Lebih praktis, sederhana, dan terhubung hanya dengan satu tap.',

    personal: {
      category: 'PERSONAL',
      title: 'Untuk Kebutuhan Personal',
      description: 'Jadikan aktivitas sehari-hari lebih praktis dengan solusi NFC yang dirancang sesuai kebutuhanmu.',
      button: 'Jelajahi Produk Personal'
    },

    business: {
      category: 'BISNIS',
      title: 'Untuk Bisnismu',
      description: 'Hubungkan produk dengan pengalaman digital dan buat interaksi dengan pelanggan menjadi lebih praktis.',
      button: 'Jelajahi Solusi Bisnis'
    },
    
    howItWorks: {
      eyebrow: 'SIAP MEMULAI?',
      title: 'Saatnya membuat semuanya',
      highlight: 'lebih mudah dengan DITAP.',
      description:
        'Aktifkan akunmu, personalisasikan halaman digital, dan berikan pengalaman yang lebih praktis kepada pelanggan dengan teknologi NFC.',
      primaryButton: 'Mulai Sekarang',
      secondaryButton: 'Hubungi Tim DITAP',
      benefits: {
        easy: 'Mudah digunakan',
        practical: 'Praktis dikelola',
        nfc: 'Didukung NFC',
      },
    },
  },

  // About

  aboutHero: {
    eyebrow: 'TENTANG DITAP',
    title: 'Menghubungkan Dunia',
    highlight: 'Fisik dan Digital.',
    description: 'DITAP menghadirkan solusi berbasis NFC yang membuat akses informasi dan interaksi menjadi lebih praktis, baik untuk kebutuhan personal maupun bisnis.',
    primaryButton: 'Jelajahi Produk',
    secondaryButton: 'Hubungi Kami',
    signature: 'TEKNOLOGI SEDERHANA. MANFAAT NYATA.'
  },

  aboutIntro: {
    status: 'Siap digunakan',
    productLabel: 'Solusi konektivitas',
    productName: 'NFC',

    floatOneTitle: 'Lebih praktis',
    floatOneText: 'Akses dalam satu tap',

    floatTwoTitle: 'Terhubung langsung',
    floatTwoText: 'Dari fisik ke digital',

    eyebrow: 'MENGENAL DITAP',
    title: 'Teknologi yang',
    highlight: 'Mempermudah Koneksi.',
    description: 'DITAP hadir untuk membuat interaksi antara dunia fisik dan digital terasa lebih mudah. Melalui teknologi NFC, informasi dapat diakses dengan cara yang lebih cepat dan praktis.',
    detail: 'Kami berfokus pada solusi yang sederhana digunakan, mudah diakses, dan dapat membantu kebutuhan personal maupun bisnis.',
    featureOne: 'Akses informasi tanpa aplikasi tambahan',
    featureTwo: 'Dapat digunakan melalui NFC',
    featureThree: 'Solusi fleksibel untuk berbagai kebutuhan',

    signature: 'DIBUAT UNTUK KONEKSI YANG LEBIH MUDAH'
  },

  aboutFeatures: {
    eyebrow: 'KEUNGGULAN DITAP',
    title: 'Satu Sentuhan,',
    highlight: 'Lebih Banyak Kemungkinan.',
    description: 'Kami menggabungkan teknologi yang praktis dengan pengalaman digital yang lebih mudah diakses.',

    cardOneTitle: 'Teknologi NFC',
    cardOneDescription: 'Cukup dekatkan ponsel yang kompatibel untuk membuka tautan atau informasi yang telah disiapkan.',
    cardOneTag: 'TAP & CONNECT',

    cardTwoTitle: 'Sekali Tap',
    cardTwoDescription: 'Cukup dekatkan ponsel ke plat NFC DITAP untuk langsung membuka halaman ulasan Google, tanpa aplikasi tambahan.',
    cardTwoTag: 'TAP & REVIEW',

    cardThreeTitle: 'Fleksibel untuk Berbagai Kebutuhan',
    cardThreeDescription: 'Solusi yang dapat diarahkan ke halaman digital sesuai tujuan penggunaan personal maupun bisnis.',
    cardThreeTag: 'FLEXIBLE SOLUTIONS',

    bottomText: 'Dirancang untuk membantu pengalaman digital terasa lebih praktis.'
  },

  aboutVision: {
    eyebrow: 'ARAH DAN TUJUAN KAMI',
    title: 'Teknologi dengan',
    highlight: 'Tujuan yang Jelas.',
    description: 'Kami ingin menjadikan teknologi sebagai penghubung yang membuat interaksi sehari-hari lebih sederhana.',

    visionLabel: 'VISI KAMI',
    visionTitle: 'Membuat koneksi terasa lebih mudah.',
    visionText: 'Menjadi bagian dari pengalaman digital yang praktis, mudah diakses, dan relevan dengan kebutuhan sehari-hari.',

    missionLabel: 'MISI KAMI',
    missionTitle: 'Berawal dari hal sederhana.',
    missionDescription: 'Kami berfokus pada tiga hal utama dalam mengembangkan solusi DITAP.',

    missionOneTitle: 'Mengutamakan kemudahan',
    missionOneText: 'Menghadirkan cara yang praktis untuk menghubungkan pengguna dengan informasi digital.',

    missionTwoTitle: 'Menggabungkan teknologi',
    missionTwoText: 'Memanfaatkan NFC agar akses informasi lebih fleksibel.',

    missionThreeTitle: 'Mendukung kebutuhan pengguna',
    missionThreeText: 'Mengembangkan solusi yang dapat disesuaikan dengan kebutuhan personal maupun bisnis.',

    footerText: 'Teknologi yang bermanfaat dimulai dari pengalaman yang mudah.'
  },

  aboutCTA: {
    eyebrow: 'LANGKAH SELANJUTNYA',
    title: 'Siap Membuat Segalanya',
    highlight: 'Lebih Praktis?',
    description: 'Mulai jelajahi solusi DITAP dan temukan cara yang lebih mudah untuk menghubungkan dunia fisik dengan pengalaman digital.',

    primaryButton: 'Jelajahi Produk',
    secondaryButton: 'Hubungi Kami',

    note: 'Temukan solusi yang sesuai dengan kebutuhanmu.',
    footer: 'JUST TAP IT. — CONNECT PHYSICAL TO DIGITAL.'
  },

  // How It Works

  howItWorksHero: {
    eyebrow: 'CARA KERJA DITAP',
    title: 'Satu sentuhan,',
    highlight: 'semua jadi mudah.',
    description: 'DITAP menggunakan teknologi NFC untuk menghubungkan pelanggan ke halaman digital yang kamu butuhkan dengan praktis.',
    primaryButton: 'Lihat Harga',
    secondaryButton: 'Hubungi Kami',
    cardLabel: 'SOLUSI NFC DITAP',
    cardTitle: 'Lebih praktis,',
    cardHighlight: 'cukup satu tap.',
    cardDescription: 'Hubungkan produk DITAP ke halaman digital untuk memberikan pengalaman yang cepat dan mudah bagi pelanggan.',
    nfcBenefit: 'Akses halaman digital melalui NFC',
    easyBenefit: 'Praktis tanpa aplikasi tambahan',
    cardFooter: 'DIBUAT UNTUK BISNIS MODERN',
    productImageAlt: 'Produk NFC DITAP',
    imagePlaceholder: 'Gambar produk DITAP',
    nfcTitle: 'Teknologi NFC',
    nfcDescription: 'Cukup dekatkan ponsel',
    easyTitle: 'Langsung terhubung',
    easyDescription: 'Akses halaman digital',
    bottomLeft: 'DIBUAT UNTUK BISNIS MODERN',
    bottomRight: 'DIDUKUNG TEKNOLOGI NFC'
  },


howItWorksSteps: {
  eyebrow: 'CARA KERJA DITAP',
  title: 'Mulai dari sini,',
  highlight: 'semudah itu.',
  description:
    'Ikuti panduan berikut untuk mengaktifkan akun, mengatur halaman digital, dan mulai menggunakan produk DITAP.',
  stepLabel: 'LANGKAH',
  visualVisit: 'Kunjungi',
  visualRegister: 'Buat akun',
  visualDashboard: 'Dashboard aktif',

  steps: {
    product: {
      title: 'Kenali produk DITAP',
      description:
        'DITAP membantu menghubungkan pelanggan ke halaman digital bisnis melalui teknologi NFC. Kenali fungsi produk sebelum memulai.',
      footer: 'MULAI DARI PRODUK DITAP',
    },

    website: {
      title: 'Kunjungi website DITAP',
      description:
        'Buka website resmi DITAP melalui browser untuk memulai proses registrasi dan mengakses layanan yang tersedia.',
      footer: 'AKSES WEBSITE RESMI',
    },

    register: {
      title: 'Daftar dan buat akun',
      description:
        'Isi formulir registrasi dengan informasi yang diperlukan. Selesaikan pendaftaran agar kamu dapat mengelola halaman digital.',
      footer: 'REGISTRASI AKUN',
    },

    dashboard: {
      title: 'Masuk ke dashboard',
      description:
        'Login menggunakan akun yang telah dibuat. Dari dashboard, kamu dapat mengakses pengaturan dan mengelola halaman DITAP.',
      footer: 'KELOLA AKUNMU',
    },

    edit: {
      title: 'Edit dan personalisasi halaman',
      description:
        'Sesuaikan informasi dan tautan tujuan halaman digitalmu. Periksa kembali hasilnya, lalu simpan perubahan sebelum digunakan.',
      footer: 'SIMPAN PERUBAHAN',
    },

    tap: {
      title: 'Gunakan produk DITAP',
      description:
        'Setelah produk siap digunakan, dekatkan ponsel yang mendukung NFC ke produk DITAP untuk membuka halaman digital yang telah ditautkan.',
      footer: 'SIAP DIGUNAKAN',
    },
  },

  note:
    'Catatan: Jika produk DITAP yang kamu terima sudah ditautkan ke halaman digital, kamu tidak perlu mengatur ulang NFC. Pastikan halaman digitalmu sudah benar sebelum membagikannya kepada pelanggan.',
},





  contact: {
    eyebrow: 'Hubungi Kami',
    title: 'Ada yang bisa kami bantu?',
    description: 'Hubungi tim Ditap untuk pertanyaan, informasi produk, atau kerja sama.',
  
    infoTitle: 'Informasi Kontak',
    infoDescription: 'Pilih cara yang paling nyaman untuk menghubungi kami.',
  
    whatsappTitle: 'WhatsApp',
    emailTitle: 'Email',
  
    formTitle: 'Kirim Pesan',
    formDescription: 'Isi formulir berikut untuk mengirim pesan langsung melalui email.',
  
    nameLabel: 'Nama',
    namePlaceholder: 'Masukkan nama kamu',
  
    emailLabel: 'Email',
    emailPlaceholder: "nama{'@'}email.com",
  
    messageLabel: 'Pesan',
    messagePlaceholder: 'Tuliskan pesan kamu di sini',
  
    submitButton: 'Kirim Email',
    privacyNote: 'Pesan akan terkirim ke Email'
  },

  terms: {
    hero: {
      eyebrow: 'Ketentuan Layanan',
      title: 'Syarat &',
      highlight: 'Ketentuan',
      description: 'Harap baca syarat dan ketentuan ini sebelum menggunakan layanan DITAP.'
    },

    lastUpdated: 'Terakhir diperbarui:',
    tocTitle: 'Daftar Isi',

    notice: 'Dengan mengakses atau menggunakan layanan DITAP, Anda dianggap telah membaca dan memahami syarat dan ketentuan yang berlaku.',

    sections: {
      introduction: {
        title: 'Pendahuluan',
        p1: 'DITAP menyediakan solusi berbasis NFC yang membantu bisnis mengarahkan pelanggan ke halaman ulasan melalui perangkat yang kompatibel.',
        p2: 'Syarat dan ketentuan ini mengatur penggunaan situs web dan layanan DITAP. Dengan mengakses atau menggunakan layanan kami, Anda setuju untuk mengikuti ketentuan yang berlaku.'
      },

      acceptance: {
        title: 'Persetujuan Ketentuan',
        p1: 'Dengan mengakses situs atau menggunakan layanan DITAP, Anda menyatakan bahwa Anda telah membaca dan memahami syarat dan ketentuan ini.',
        p2: 'Jika Anda tidak menyetujui ketentuan ini, mohon untuk tidak menggunakan layanan yang bersangkutan.'
      },

      services: {
        title: 'Layanan DITAP',
        p1: 'DITAP menyediakan solusi NFC yang dapat digunakan untuk membuka tautan tujuan, termasuk halaman ulasan bisnis yang dipilih oleh pengguna atau pemilik bisnis.',
        p2: 'Fitur, ketersediaan, dan ketentuan layanan dapat berubah seiring pengembangan produk. Informasi mengenai fitur tertentu akan mengikuti keterangan yang tersedia pada saat layanan digunakan.'
      },

      nfc: {
        title: 'Penggunaan NFC',
        p1: 'Fungsi NFC bergantung pada kompatibilitas perangkat, pengaturan ponsel, dan kondisi teknis perangkat yang digunakan. Pengguna perlu memastikan bahwa perangkat mereka mendukung penggunaan NFC jika fitur tersebut diperlukan.',
        p2: 'DITAP tidak menjamin setiap perangkat dapat membuka tautan dengan cara yang sama. Pengalaman penggunaan juga dapat dipengaruhi oleh koneksi internet dan layanan tujuan.'
      },

      responsibilities: {
        title: 'Hak dan Tanggung Jawab Pengguna',
        p1: 'Dalam menggunakan layanan DITAP, Anda bertanggung jawab untuk:',
        l1: 'Memberikan informasi yang benar ketika menghubungi atau menggunakan layanan kami.',
        l2: 'Menggunakan layanan untuk tujuan yang sah dan tidak melanggar hukum yang berlaku.',
        l3: 'Tidak menyalahgunakan layanan, mencoba mengganggu sistem, atau mengakses bagian yang tidak diizinkan.',
        l4: 'Memastikan bahwa tautan tujuan yang Anda gunakan sesuai dengan hak dan izin yang Anda miliki.'
      },

      intellectualProperty: {
        title: 'Hak Kekayaan Intelektual',
        p1: 'Nama DITAP, logo, desain, elemen visual, dan materi lain yang dimiliki DITAP dilindungi oleh ketentuan hak kekayaan intelektual yang berlaku.',
        p2: 'Anda tidak diperkenankan menyalin, mendistribusikan, memodifikasi, atau menggunakan materi milik DITAP di luar izin yang diberikan atau ketentuan hukum yang berlaku.'
      },

      thirdParty: {
        title: 'Layanan Pihak Ketiga',
        p1: 'Layanan DITAP dapat mengarahkan pengguna ke platform pihak ketiga, termasuk layanan ulasan bisnis. Platform tersebut memiliki ketentuan dan kebijakan sendiri.',
        p2: 'DITAP tidak mengendalikan seluruh layanan, konten, ketersediaan, atau kebijakan platform pihak ketiga. Penggunaan platform tersebut tunduk pada ketentuan penyedia yang bersangkutan.'
      },

      availability: {
        title: 'Ketersediaan Layanan',
        p1: 'Kami berupaya menjaga layanan tetap dapat digunakan, tetapi tidak menjamin bahwa situs atau seluruh fitur akan selalu tersedia tanpa gangguan. Pemeliharaan, masalah jaringan, dan keadaan di luar kendali kami dapat memengaruhi ketersediaan layanan.'
      },

      liability: {
        title: 'Batasan Tanggung Jawab',
        p1: 'Sejauh diizinkan oleh hukum yang berlaku, DITAP tidak bertanggung jawab atas gangguan yang disebabkan oleh perangkat pengguna, jaringan, atau layanan pihak ketiga yang berada di luar kendali langsung kami.',
        p2: 'Tidak ada bagian dari ketentuan ini yang dimaksudkan untuk mengesampingkan hak atau tanggung jawab yang tidak dapat dikesampingkan berdasarkan hukum yang berlaku.'
      },

      changes: {
        title: 'Perubahan Ketentuan',
        p1: 'DITAP dapat memperbarui syarat dan ketentuan ini dari waktu ke waktu. Perubahan akan ditampilkan pada halaman ini bersama tanggal pembaruan yang relevan. Penggunaan layanan setelah perubahan ditampilkan tunduk pada ketentuan yang berlaku, sejauh diizinkan oleh hukum.'
      },

      contact: {
        title: 'Hubungi Kami',
        p1: 'Jika Anda memiliki pertanyaan mengenai syarat dan ketentuan ini, silakan hubungi kami melalui email: {email}.'
      }
    },

    contact: {
      eyebrow: 'Butuh Bantuan?',
      title: 'Ada pertanyaan tentang ketentuan?',
      description: 'Hubungi tim DITAP jika Anda membutuhkan penjelasan lebih lanjut mengenai syarat dan ketentuan layanan.',
      button: 'Hubungi Kami'
    }
  },

  privacyPolicy: {
    hero: {
      eyebrow: 'Privasi Anda',
      title: 'Kebijakan',
      highlight: 'Privasi',
      description: 'Kami menghargai privasi Anda. Halaman ini menjelaskan bagaimana informasi dapat diproses ketika Anda mengakses situs dan layanan DITAP.'
    },

    lastUpdated: 'Terakhir diperbarui:',
    tocTitle: 'Daftar Isi',

    notice: 'Kebijakan ini menjelaskan prinsip umum perlindungan privasi DITAP. Informasi yang benar-benar diproses bergantung pada fitur yang Anda gunakan dan layanan pihak ketiga yang terlibat.',

    sections: {
      overview: {
        title: 'Pendahuluan',
        p1: 'DITAP menyediakan solusi berbasis NFC yang membantu pelanggan mengakses halaman ulasan bisnis melalui perangkat yang kompatibel.',
        p2: 'Kebijakan ini menjelaskan prinsip penanganan informasi, penggunaan layanan, dan pilihan yang dapat Anda ambil terkait privasi.'
      },

      information: {
        title: 'Informasi yang Dapat Berkaitan dengan Layanan',
        p1: 'Jenis informasi yang mungkin diproses bergantung pada cara Anda menggunakan layanan. Informasi tersebut dapat mencakup:',
        l1: 'Informasi yang Anda berikan secara langsung ketika menghubungi kami, seperti nama, alamat email, dan isi pesan.',
        l2: 'Informasi teknis yang mungkin diproses oleh situs atau penyedia hosting, seperti jenis peramban, perangkat, alamat IP, dan catatan akses, bergantung pada konfigurasi layanan.',
        l3: 'Informasi yang diproses oleh platform pihak ketiga ketika Anda membuka layanan mereka melalui tautan dari DITAP.'
      },

      usage: {
        title: 'Bagaimana Informasi Dapat Digunakan',
        p1: 'Apabila informasi diproses dalam penggunaan layanan, informasi tersebut dapat digunakan untuk tujuan yang relevan, seperti:',
        l1: 'Menanggapi pertanyaan, masukan, atau permintaan dukungan.',
        l2: 'Mengoperasikan, memelihara, dan meningkatkan situs serta layanan DITAP.',
        l3: 'Membantu menjaga keamanan, mendeteksi penyalahgunaan, dan menangani gangguan teknis.',
        l4: 'Memenuhi kewajiban hukum yang berlaku apabila diwajibkan.'
      },

      nfc: {
        title: 'Penggunaan NFC dan Halaman Ulasan',
        p1: 'Plat NFC DITAP dirancang untuk membantu perangkat yang kompatibel membuka tautan tujuan, misalnya halaman ulasan bisnis. Penggunaan NFC tidak dengan sendirinya memberikan DITAP akses ke seluruh isi ponsel Anda.',
        p2: 'Setelah tautan dibuka, pemrosesan informasi pada halaman tujuan mengikuti kebijakan dan pengaturan platform yang bersangkutan. DITAP tidak mengendalikan seluruh praktik pengumpulan data oleh platform eksternal tersebut.'
      },

      thirdParties: {
        title: 'Layanan dan Tautan Pihak Ketiga',
        p1: 'Situs atau tautan yang tersedia melalui DITAP dapat mengarahkan Anda ke layanan pihak ketiga, termasuk platform ulasan. Layanan tersebut memiliki kebijakan privasi dan ketentuan masing-masing.',
        p2: 'Kami menyarankan Anda membaca kebijakan privasi platform terkait sebelum memberikan informasi atau menggunakan fitur mereka. Praktik privasi pihak ketiga berada di luar kendali langsung DITAP.'
      },

      security: {
        title: 'Keamanan Informasi',
        p1: 'Perlindungan informasi perlu disesuaikan dengan jenis data dan cara data diproses. DITAP berupaya menerapkan langkah yang wajar sesuai layanan yang digunakan, tetapi tidak ada metode transmisi atau penyimpanan elektronik yang dapat dijamin sepenuhnya aman.'
      },

      retention: {
        title: 'Penyimpanan Informasi',
        p1: 'Lama penyimpanan informasi, apabila ada, bergantung pada tujuan penggunaannya, kebutuhan operasional, serta kewajiban hukum yang berlaku. Informasi seharusnya tidak disimpan lebih lama daripada yang diperlukan untuk tujuan yang sah.'
      },

      rights: {
        title: 'Pilihan dan Hak Anda',
        p1: 'Bergantung pada ketentuan hukum yang berlaku dan situasi pemrosesan, Anda dapat mengajukan permintaan terkait informasi pribadi yang Anda berikan kepada DITAP, antara lain:',
        l1: 'Meminta informasi mengenai penggunaan data pribadi Anda.',
        l2: 'Meminta koreksi atau penghapusan informasi yang relevan, apabila dapat dilakukan dan tidak bertentangan dengan kewajiban hukum.',
        l3: 'Mengajukan pertanyaan atau keberatan terkait pemrosesan informasi pribadi.'
      },

      children: {
        title: 'Privasi Anak',
        p1: 'Situs DITAP tidak secara khusus ditujukan kepada anak-anak. Jika Anda meyakini bahwa seorang anak telah memberikan informasi pribadi kepada kami, silakan hubungi kami agar situasinya dapat ditinjau.'
      },

      changes: {
        title: 'Perubahan Kebijakan',
        p1: 'Kami dapat memperbarui kebijakan privasi ini dari waktu ke waktu. Perubahan akan ditampilkan pada halaman ini bersama tanggal pembaruan yang relevan. Kami menyarankan Anda meninjau halaman ini secara berkala.'
      },

      contact: {
        title: 'Hubungi Kami',
        p1: 'Jika Anda memiliki pertanyaan mengenai kebijakan privasi ini atau ingin menyampaikan permintaan terkait informasi pribadi, hubungi kami melalui email: {email}.'
      }
    },

    contact: {
      eyebrow: 'Butuh Bantuan?',
      title: 'Ada pertanyaan tentang privasi?',
      description: 'Hubungi tim DITAP jika Anda ingin bertanya mengenai kebijakan privasi atau informasi pribadi.',
      button: 'Hubungi Kami'
    }
  },

  blog: {
    hero: {
      eyebrow: 'DITAP JOURNAL',
      title: 'Wawasan digital untuk',
      highlight: 'dunia yang lebih terhubung.',
      description: 'Temukan inspirasi seputar teknologi NFC, identitas digital, dan solusi praktis untuk personal maupun bisnis.'
    },
    searchPlaceholder: 'Cari artikel...',
    searchLabel: 'Cari artikel blog',
    searchButton: 'Cari',
    articlesEyebrow: 'JELAJAHI IDE',
    latestTitle: 'Artikel terbaru',
    latestDescription: 'Pengetahuan untuk langkah digital kamu berikutnya.',
    articleCount: 'artikel',
    allCategories: 'Semua artikel',
    readMore: 'Baca selengkapnya',
    errorTitle: 'Artikel belum dapat dimuat',
    errorDescription: 'Terjadi kesalahan saat mengambil artikel.',
    retry: 'Coba lagi',
    noResultsTitle: 'Artikel tidak ditemukan',
    noResultsDescription: 'Coba kata kunci lain.',
    emptyTitle: 'Cerita pertama segera hadir',
    emptyDescription: 'Kami sedang menyiapkan wawasan menarik seputar NFC dan identitas digital.',
    resetFilters: 'Tampilkan semua artikel',
    paginationLabel: 'Navigasi halaman blog',
    previous: 'Sebelumnya',
    next: 'Selanjutnya',

    backToBlog: 'Kembali ke Blog',
    detailErrorTitle: 'Artikel tidak dapat dimuat',
    readingMinutes: 'menit membaca',
    emptyContent: 'Konten artikel belum tersedia.',
    tagsLabel: 'Topik:',
    relatedEyebrow: 'LANJUTKAN MEMBACA',
    relatedTitle: 'Artikel terkait',
    viewAll: 'Lihat semua',
    notFoundDescription: 'Artikel yang kamu cari tidak ditemukan.',
    // errorDescription: 'Terjadi kesalahan saat mengambil artikel.',
    // retry: 'Coba lagi'
  },
  faqPage: {
    hero: {
      eyebrow: 'PUSAT BANTUAN DITAP',
      title: 'Bagaimana kami bisa',
      highlight: 'membantu kamu?',
      description:
        'Temukan jawaban atas pertanyaan seputar DITAP, teknologi NFC, QR Code, dan layanan identitas digital kami.'
    },
  
    searchPlaceholder: 'Cari pertanyaan...',
    searchLabel: 'Cari pertanyaan FAQ',
    searchButton: 'Cari',
  
    questionsEyebrow: 'PERTANYAAN UMUM',
    latestTitle: 'Pertanyaan yang sering diajukan',
    latestDescription:
      'Jawaban singkat untuk pertanyaan paling umum seputar DITAP.',
  
    questionCount: 'pertanyaan',
  
    tabs: {
      umum: 'Umum',
      bisnis: 'Bisnis'
    },
  
    emptyTitle: 'Belum ada pertanyaan',
    emptyDescription: 'Silakan cek kembali nanti.',
    noResultsTitle: 'Pertanyaan tidak ditemukan',
    noResultsDescription:
      'Kami tidak menemukan pertanyaan yang sesuai. Coba kata kunci lain.',
    resetFilters: 'Reset pencarian',
  
    previous: 'Sebelumnya',
    next: 'Berikutnya',
    paginationLabel: 'Navigasi halaman FAQ',
  
    questions: {
      what: {
        question: 'Apa itu DITAP?',
        answer:
          'DITAP adalah platform identitas digital yang memungkinkan pengguna membagikan informasi dan profil digital melalui teknologi NFC dan QR Code.'
      },
      purpose: {
        question: 'Apa tujuan utama DITAP?',
        answer:
          'DITAP hadir untuk mempermudah berbagi identitas dan informasi digital secara praktis. Cukup satu kali tap atau scan untuk mengakses halaman digital.'
      },
      nfc: {
        question: 'Apa itu teknologi NFC pada DITAP?',
        answer:
          'NFC (Near Field Communication) adalah teknologi komunikasi jarak dekat yang memungkinkan smartphone membaca tag NFC dengan mendekatkannya ke perangkat.'
      },
      compatibility: {
        question: 'Apakah semua smartphone bisa menggunakan NFC?',
        answer:
          'Tidak semua smartphone memiliki fitur NFC. Perangkat harus mendukung pembacaan NFC dan fitur tersebut harus diaktifkan. Jika smartphone tidak mendukung NFC, kamu tetap dapat mengakses halaman DITAP melalui QR Code.'
      },
      app: {
        question:
          'Apakah saya perlu menginstal aplikasi untuk menggunakan NFC?',
        answer:
          'Pada smartphone yang mendukung pembacaan NFC, umumnya kamu tidak perlu menginstal aplikasi tambahan. Cukup dekatkan smartphone ke produk NFC DITAP untuk membuka tautan digital.'
      },
      qr: {
        question: 'Apakah DITAP mendukung QR Code?',
        answer:
          'Ya. DITAP mendukung akses melalui QR Code sehingga pengguna dapat membuka halaman digital dengan memindai kode menggunakan kamera smartphone.'
      },
      activation: {
        question: 'Bagaimana cara mengaktifkan akun DITAP?',
        answer:
          'Gunakan kode aktivasi yang diberikan bersama produk DITAP. Ikuti petunjuk aktivasi untuk mengatur identitas dan informasi akun kamu.'
      },
      profile: {
        question: 'Apakah saya bisa mengubah informasi profil?',
        answer:
          'Ya. Setelah akun aktif, kamu dapat mengelola dan memperbarui informasi pada halaman digital melalui akun DITAP sesuai fitur yang tersedia.'
      },
      privacy: {
        question: 'Apakah informasi pribadi saya aman?',
        answer:
          'DITAP berupaya menjaga keamanan informasi pengguna. Kami menyarankan pengguna untuk tidak membagikan kode aktivasi atau informasi login kepada orang lain.'
      },
      update: {
        question:
          'Apakah saya harus mengganti kartu NFC ketika memperbarui profil?',
        answer:
          'Tidak. Selama tautan digital tetap sama dan produk NFC berfungsi dengan baik, informasi profil dapat diperbarui tanpa perlu menulis ulang kartu NFC.'
      }
    },
  
    bisnisQuestions: {
      pricing: {
        question: 'Bagaimana skema harga untuk kebutuhan bisnis?',
        answer:
          'DITAP menawarkan paket bisnis yang dapat disesuaikan dengan jumlah kartu NFC, jumlah pengguna, dan kebutuhan integrasi. Hubungi tim sales kami untuk penawaran resmi.'
      },
      plan: {
        question: 'Apa perbedaan paket personal dan bisnis?',
        answer:
          'Paket bisnis menyediakan fitur tambahan seperti manajemen tim, analitik kunjungan, kustom branding, dan dukungan prioritas yang tidak tersedia pada paket personal.'
      },
      invoice: {
        question:
          'Apakah tersedia invoice resmi untuk pembelian perusahaan?',
        answer:
          'Ya. Setiap pembelian paket bisnis akan disertai invoice resmi yang dapat digunakan untuk keperluan administrasi dan pajak perusahaan.'
      },
      refund: {
        question: 'Bagaimana kebijakan refund untuk paket bisnis?',
        answer:
          'Kebijakan refund mengikuti ketentuan yang berlaku pada saat pembelian. Silakan hubungi tim support kami untuk informasi lebih detail sesuai kontrak.'
      },
      seats: {
        question:
          'Apakah saya bisa menambah jumlah pengguna di kemudian hari?',
        answer:
          'Tentu. Paket bisnis bersifat fleksibel, kamu dapat menambah jumlah pengguna kapan saja dan penagihan akan disesuaikan secara proporsional.'
      },
      roles: {
        question: 'Apakah ada pengaturan peran dan hak akses tim?',
        answer:
          'Ya. Admin utama dapat mengatur peran anggota tim, termasuk hak akses untuk mengelola profil, kartu NFC, dan laporan analitik.'
      },
      api: {
        question: 'Apakah DITAP menyediakan API untuk integrasi?',
        answer:
          'Paket bisnis mendukung akses API sehingga kamu dapat mengintegrasikan data identitas digital DITAP dengan sistem internal perusahaan.'
      },
      crm: {
        question: 'Bisakah DITAP terhubung dengan CRM yang kami gunakan?',
        answer:
          'DITAP dapat diintegrasikan dengan berbagai CRM populer melalui API atau middleware. Tim kami dapat membantu proses integrasi sesuai kebutuhan.'
      },
      sla: {
        question: 'Apakah ada jaminan SLA untuk klien bisnis?',
        answer:
          'Ya. Klien bisnis mendapatkan jaminan SLA dengan waktu respons dukungan yang lebih cepat dibanding paket personal, sesuai ketentuan kontrak.'
      },
      contact: {
        question: 'Bagaimana cara menghubungi tim sales bisnis?',
        answer:
          'Kamu dapat menghubungi tim sales melalui tombol Hubungi Kami di halaman ini, atau mengirim email ke alamat resmi yang tertera pada halaman kontak.'
      }
    }
  },

  notFound: {
    title: 'Halaman tidak ditemukan',
    description: 'Maaf, halaman yang kamu cari tidak tersedia atau mungkin sudah dipindahkan.',
    button: 'Kembali ke Beranda'
  }
}
